import TopBar from "../components/TopBar";

export default function SettingsPage() {
  return (
    <>
      <TopBar crumbs={["Налаштування"]} />
      <div className="content" style={{ maxWidth: 720 }}>
        <h1>Налаштування</h1>
        <div className="card pad" style={{ marginTop: 12 }}>
          <h2>AI-сервіси</h2>
          <div className="hint" style={{ lineHeight: 1.8 }}>
            Ключі зберігаються як секрети Cloudflare Pages (не у фронтенді):
            <ul>
              <li><code>FREEPIK_KEY</code> — Mystic/Flux (кадри) + Kling 3 (відео)</li>
              <li><code>GEMINI_KEY</code> — аналіз референс-відео</li>
              <li><code>ANTHROPIC_KEY</code> — розбивка на сцени</li>
              <li><code>FOREPLAY_KEY</code> — підтягування референсу (опц.)</li>
            </ul>
            Локально: <code>.dev.vars</code>. Прод: <code>wrangler pages secret put NAME</code>.
          </div>
        </div>
        <div className="card pad" style={{ marginTop: 16 }}>
          <h2>Моделі за замовчуванням</h2>
          <div className="hint">
            Mystic <code>realism / editorial_portraits</code> · Kling <code>kling-v3 / kling-v3-omni</code> · Gemini <code>gemini-2.5-pro</code> · Claude <code>sonnet-4.5</code>. Налаштовуються у <code>wrangler.toml [vars]</code>.
          </div>
        </div>
      </div>
    </>
  );
}
